import DeviceManager from '../utils/device-manager';
import $ from "jquery";
import Flickity from "flickity-fade";
import "flickity-imagesloaded";

class GallerySlider {
	constructor($el) {
		this.$el = $el;

		this.options = {
			autoPlay: true,
			pageDots: true,
			wrapAround: true,
			prevNextButtons: true,
			freeScroll: true,
			cellSelector: ".section-gallery__item",
			cellAlign: "left"
		};

		if (this.$el.length) {
			this._init();
			this._bindEvents();
		}
	}

    _init() {
        this.$slides = this.$el.find('.section-gallery__item');
        this.slidesCount = this.$slides.length;

		if (document.body.clientWidth >= 1024 && this.slidesCount > 3) {
            // this._createSlider();
			this.slider = new Flickity(this.$el[0], this.options);
			// console.log('Gallery slider - Desktop');
        } else if (document.body.clientWidth < 1024 && document.body.clientWidth >= 768 && this.slidesCount > 2) {
            // this._createSlider();
			this.slider = new Flickity(this.$el[0], this.options);
			// console.log('Gallery slider - Tablet');
		} else if (document.body.clientWidth < 768 && this.slidesCount > 1) {
            // this._createSlider();
			this.slider = new Flickity(this.$el[0], this.options);
			// console.log('Gallery slider - Mobile');
        } else {
            this._destroy();
			// console.log('Destroy gallery slider');
        }
    }

	_destroy() {
        if(this.slider) {
            this.slider.destroy();
            this.slider = null;
        }
    }

	_bindEvents() {
        this._onBreakpointChangeFn = this._onBreakpointChange.bind(this);

        DeviceManager.on('device-manager:breakpointChange', this._onBreakpointChangeFn);
    }

	_onBreakpointChange() {
		if (document.body.clientWidth >= 1024 && this.slidesCount > 3) {
            // this._createSlider();
			this.slider = new Flickity(this.$el[0], this.options);
			// console.log('Gallery slider - Resize desktop');
        } else if (document.body.clientWidth < 1024 && document.body.clientWidth >= 768 && this.slidesCount > 2) {
            // this._createSlider();
			this.slider = new Flickity(this.$el[0], this.options);
			// console.log('Gallery slider - Resize tablet');
		} else if (document.body.clientWidth < 768 && this.slidesCount > 1) {
            // this._createSlider();
			this.slider = new Flickity(this.$el[0], this.options);
			// console.log('Gallery slider - Resize mobile');
        } else {
            this._destroy();
			// console.log('Resize - Destroy gallery slider');
        }
	}

	/* _createSlider() {
        new Flickity(this.$el[0], this.options);
    } */
}

export default GallerySlider;
